import React, { useState } from "react"
import { Card, CardBody, Button, Container, Row, Col } from "reactstrap"
import pulaAwardsContent from "../../assets/images/users/pula_awards_content.png"
import pulaMarketContent from "../../assets/images/users/marketing-pula.webp"
import { Link } from "react-router-dom"

const AwardsInfo = () => {
  const [showUpdateButton, setShowUpdateButton] = useState(true)

  return (
    <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div className="container-fluid" style={{ padding: 0 }}>
        {false && (
          <div
            style={{
              width: "100%",
              background: "linear-gradient(135deg, #f5f0f8 0%, #e8dff0 100%)",
              padding: "1.5rem 2rem",
            }}
          >
            <Row className="align-items-start">
              <Col md={8}>
                <h3
                  className="mb-2 text-black"
                  style={{
                    fontSize: "1.8rem",
                    fontWeight: "700",
                    color: "#2d2d2d",
                  }}
                >
                  Awards
                </h3>
                <h4
                  className="mb-3 text-black"
                  style={{
                    fontSize: "1.4rem",
                    fontWeight: "600",
                    color: "#2d2d2d",
                  }}
                >
                  Bookings On 18 Jan 2026
                </h4>
                <p
                  style={{
                    fontSize: "1.3rem",
                    color: "#555",
                    marginBottom: "2rem",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <i
                    className="mdi mdi-map-marker"
                    style={{ fontSize: "1.5rem" }}
                  ></i>
                  Amanora Mall @ 8AM
                </p>
              </Col>
              <Col md={4} className="text-end">
                <Button color="primary" className="btn-lg" type="submit">
                  Update My Details <i className="mdi mdi-arrow-right ms-2"></i>
                </Button>
              </Col>
            </Row>

            <div
              style={{
                width: "100%",
                height: "8px",
                background:
                  "linear-gradient(90deg, #7cb342 0%, #7cb342 40%, #e0e0e0 40%, #e0e0e0 100%)",
                borderRadius: "4px",
              }}
            />
          </div>
        )}

        <div className="justify-content-center p-5 h-100">
          <h3 className="h3 mb-4 nom-title">About PULA Entrepreneur Awards</h3>

          <Row className="align-items-start ">
            <Col md={7}>
              <p
                style={{
                  color: "#7a6b8a",
                  fontSize: "1.05rem",
                  lineHeight: "1.8",
                }}
              >
                The PULA Entrepreneur Awards is a celebration of women who dare
                to build, lead, and inspire. Rooted in the PULA (Pune Ladies)
                community, these awards honor the resilience, innovation, and
                impact of women entrepreneurs across diverse industries. From
                early-stage founders to established business leaders, the awards
                spotlight journeys that reflect courage, consistency, and
                meaningful contribution to society. These remarkable women
                exemplify the spirit of entrepreneurship and serve as beacons of
                inspiration for future generations.
              </p>
            </Col>
            <Col md={5} className="d-flex align-items-center">
              <img
                src={pulaAwardsContent}
                alt="PULA Awards Event"
                className="img-fluid rounded shadow-sm"
                style={{ width: "100%", objectFit: "cover" }}
              />
            </Col>
          </Row>

          <p
            style={{
              color: "#7a6b8a",
              fontSize: "1.05rem",
              lineHeight: "1.8",
              marginBottom: "0",
            }}
          >
            At PULA, we believe every woman's story deserves recognition
            especially those who grow businesses while uplifting others along
            the way. The Entrepreneur Awards are designed to be transparent,
            inclusive, and purpose-driven, offering women a credible platform to
            showcase their work, gain visibility, and be acknowledged for their
            efforts. More than just trophies, the awards represent validation,
            encouragement, and a powerful reminder that women-led businesses
            matter.
          </p>
          <p
            style={{
              color: "#7a6b8a",
              fontSize: "1.05rem",
              lineHeight: "1.8",
              marginBottom: "2rem",
            }}
          >
            Beyond recognition, the PULA Entrepreneur Awards foster a strong
            ecosystem of connection and growth. Awardees and nominees become
            part of a supportive network that opens doors to mentorship,
            collaboration, media exposure, and community leadership. Through
            these awards, PULA continues its mission to amplify women’s voices,
            celebrate their achievements, and inspire the next generation of
            women entrepreneurs to step forward with confidence.
          </p>
        </div>
      </div>
    </div>
  )
}

export default AwardsInfo
